const ON_THE_BEACH_AGENCY_IDS = ['21608', '21610', '21611'];

export default ON_THE_BEACH_AGENCY_IDS;



// WEBPACK FOOTER //
// ./client/app/common/auth/onTheBeachAgencyIds.js